'use client';

import Body from '../../../../components/Body/Body';
import Button from '../../../../components/Button/Button';
import { useValRoute } from '../../../../val/val.client';
import Layout from '../../../../containers/Layout';
import pageVal from './page.val';
import { notFound } from 'next/navigation';

const KaffepratSuccess = ({ params }: { params: Promise<never> }) => {
  const page = useValRoute(pageVal, params);
  if (!page) {
    return notFound();
  }
  const { formSuccessTitle, formSuccessText, backButton } = page;

  return (
    <Layout>
      <div className="flex flex-col items-center gap-9 text-center">
        <h1 className="font-respira text-[3.5rem] desktop:text-[4rem] text-pretty">
          {formSuccessTitle}
        </h1>

        <div className="max-w-[600px]">
          <Body>{formSuccessText}</Body>
        </div>

        <Button className="mt-6" href={backButton.href}>
          {backButton.text}
        </Button>
      </div>
    </Layout>
  );
};

export default KaffepratSuccess;
